export default __webpack_public_path__ + "static/media/z010mi0a.6acf6a45.mp3";